import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { BillingRecord } from 'src/models';
import { RootState } from 'src/store';
import { billingSelectors } from 'src/store/reducers/billing';

export const useBillingState = (): RootState['billing'] => {
  const state = useSelector<RootState, RootState['billing']>(
    (state) => state.billing,
  );

  useDebugValue(state);

  return state;
};

export const useBilling = (): BillingRecord[] => {
  const state = useSelector<RootState, RootState['billing']>(
    (state) => state.billing,
  );

  const records = billingSelectors.selectAll(state);

  useDebugValue(state);

  return records;
};
